import { createFileRoute } from "@tanstack/react-router";
import { BrandStatusPage } from "@/components/BrandStatusPage";

export const Route = createFileRoute("/403")({
  component: () => (
    <BrandStatusPage
      code="403"
      title="Không có quyền"
      description="Tài khoản của bạn chưa được mở trang này. Cần thì nhờ quản lý cấp quyền."
    />
  ),
});
